import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { LiveProvider } from "@/components/LiveFeed";
import InstallPrompt from "@/components/InstallPrompt";
import { TipsProvider } from "@/components/Tips";
import { CookieConsent } from "@/components/CookieConsent";
import { publicRoutes, portalRoutes, adminRoutes } from "@/routes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
        <LanguageProvider>
        <LiveProvider>
        <TipsProvider>
          <Toaster position="top-right" richColors />
          <CookieConsent />
          <InstallPrompt />
          <Routes>
            {publicRoutes}
            {portalRoutes}
            {adminRoutes}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </TipsProvider>
        </LiveProvider>
        </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
